import { ILockerGateItem } from 'api/interfaces/lockerGate';
import { memo } from 'react';
import { useLocation } from 'react-router-v7';
import { StyledRowItemMemoGrid } from '../StyledComponents';
import { LockerItem } from './LockerItem';
import { GateItem } from './GateItem';
import { ZoneItem } from './ZoneItem';

interface RowItemMemoProps extends ILockerGateItem {}

export const RowItemMemo = memo<RowItemMemoProps>((props: RowItemMemoProps) => {
	const lockerGateItem = props;
	const { id } = lockerGateItem;
	const { hash } = useLocation();

	const isZoneItem = lockerGateItem.alarmZoneMode != null;
	const isGatedItem = !lockerGateItem.isLocker && !isZoneItem;
	const isLockerItem = lockerGateItem.isLocker;

	return (
		<div id={id}>
			<StyledRowItemMemoGrid container active={hash.includes(id).toString()}>
				{isZoneItem && <ZoneItem lockerGateItem={lockerGateItem} />}
				{isGatedItem && <GateItem lockerGateItem={lockerGateItem} />}
				{isLockerItem && <LockerItem lockerGateItem={lockerGateItem} />}
			</StyledRowItemMemoGrid>
		</div>
	);
});
